import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import {axios} from '@/lib/axios';
import {useLoadingStore} from '@/stores/loading';
import {useMessageModalStore} from "@/stores/message";
import * as Config from '@/config'
import * as PfAPI from '@/api/pf';
import {useMapDrawing} from "@/stores/mapDrawing";
import Map from '@/components/Map';

type MapModalProps = {
  isShow: boolean;
  dataId: number;
  onCancel?: () => void;
};

function MapModal(props: MapModalProps) {

  const modalRoot = document.getElementById("modal-root");
  const setLoading = useLoadingStore(state => state.setLoading);
  const setMessage = useMessageModalStore(state => state.setMessage);
  const {coordinate, setCoordinate} = useMapDrawing();
  const [resultMessaga, setresultMessaga] = useState<string | undefined>('')

  const mapConfirmWithKey = async (key: string) => {
    setLoading(true);
    const authRes = await PfAPI.authentication().catch(() => {
      setMessage(Config.MESSAGE_NO_E39);
      setLoading(false);
    });

    if (!authRes) return;

    //console.log("featureKey=" + key);

    PfAPI.getCoordinate(authRes, key).then(result => {
      setCoordinate(result);
    }).catch(() => {
      setMessage(Config.MESSAGE_NO_E39);
    }).finally(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    const fetchFeatureKeyAndCoordinate = async () => {
      setLoading(true);
      setCoordinate(undefined);
      setresultMessaga(undefined);

      try {
        const response = await axios.post('/api/v1/datas/getFeatureKey', {
          id: props.dataId
        });

        const key = response.data.feature_key;
        //console.log(key);

        if (key) {
          await mapConfirmWithKey(key);
        } else {
          setresultMessaga('要望地点の登録がありません。');
        }
      } catch (error) {
        setMessage(Config.MESSAGE_NO_E39);
      } finally {
        setLoading(false);
      }
    };

    if (props.isShow) {
      fetchFeatureKeyAndCoordinate();
    }
  }, [props.isShow]);

  return (
    modalRoot && props.isShow ?
      createPortal(
        <div className="modal2">
          <div className="modal2-content">
            <div className="modal2-text">
              <div className="uk-position-relative height-300">{
                coordinate ? <Map geojsonData={coordinate}/> : resultMessaga
              }</div>
            </div>
            <div className="modal2-buttons">
              <button
                onClick={props.onCancel}
                className="uk-button--m uk-button-cancel"
              >
                閉じる
              </button>
          </div>
        </div>
      </div>, modalRoot
      )
        : null
  );
}

export default MapModal;
